import {Component, Input, OnInit} from '@angular/core';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {Subject} from 'rxjs';
import {GridValueChangeEvent} from '@shared/models/common.models';

@Component({
    standalone: false,
    selector: 'app-orbitax-connect-view',
  templateUrl: './orbitax-connect-view.component.html',
  styleUrls: ['./orbitax-connect-view.component.css']
})
export class OrbitaxConnectViewComponent implements OnInit {

  @Input() magicLinkModel: MagicLinkModel;
  @Input() handler: IPlatformToolHandler;
  @Input() selectedTab: TabModel;
  @Input() invalidateSubject: InvalidateSubject = new InvalidateSubject();
  public isClientDrive = true;
  public unsubscribe$ = new Subject<void>();
  isReady = false;
  showRecentPanel = true;
  api = 'FileStoreApi';

  constructor() { }

  ngOnInit(): void {}

  onSelectionChanged($event: GridValueChangeEvent) {}

  onGridCellValueChange($event: GridValueChangeEvent) {}
}
